module.exports = __webpack_public_path__ + "assets/img/passport.bc66a734.png";